import { customToast } from "../../../../shared";
import { changeSurveyPreferencesService } from "../../services";
import {
  withSpinner,
  success,
  failure,
} from "../../../../redux/actions/utilities";
import {
  successMessages,
  changeSurveyPreferencesConstants,
  toastTypes,
} from "../../constants";

const { UPDATED_SUCCESSFULLY } = successMessages;
const { GET_SURVEY_PREFERENCES } = changeSurveyPreferencesConstants;

const getSurveyPreferences = (encryptedParams) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_SURVEY_PREFERENCES, () =>
      changeSurveyPreferencesService
        .getSurveyPreferences(encryptedParams)
        .then(
          (response) => {
            dispatch(success(response, GET_SURVEY_PREFERENCES));
          },
          (error) => {
            dispatch(failure(null, GET_SURVEY_PREFERENCES));
          }
        )
    );
  };
};

//Update survey preferences
const updateSurveyPreferences = (encryptedParams, body) => {
  return (dispatch) => {
    return withSpinner(dispatch, GET_SURVEY_PREFERENCES, () =>
      changeSurveyPreferencesService
        .updateSurveyPreferences(body)
        .then(
          (_response) => {
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(getSurveyPreferences(encryptedParams));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

export const changeSurveyPreferencesActions = {
  getSurveyPreferences,
  updateSurveyPreferences,
};
